/* Headsets.com-hosted Anita widget copy.
   Source: https://www.headsets.com/apps/anita/widget.js?v=20260528-proxy
   Synced: 2026-07-15 by Dave for preview theme 149916975266.
   Reason: avoid loading the widget JS through an off-site/proxy app URL; keep API base configured separately. */
(function() {
  const botpoisonScript = document.createElement('script');
  botpoisonScript.src = 'https://unpkg.com/@botpoison/browser';
  botpoisonScript.async = true;
  document.head.appendChild(botpoisonScript);
  'use strict';

  function getDefaultApiBase() {
    const fallback = 'https://anita.zipdex.com';
    const script = document.currentScript || document.querySelector('script[src*="/apps/anita/widget.js"]');
    let scriptUrl;

    try {
      scriptUrl = script && script.src ? new URL(script.src, window.location.href) : null;
    } catch {
      scriptUrl = null;
    }

    const hostname = scriptUrl?.hostname || window.location.hostname;
    const pathname = scriptUrl?.pathname || '';
    const supportsAnitaAppProxy = [
      'www.headsets.com',
      'headsets.com',
      'www.leitnerheadsets.com',
      'leitnerheadsets.com',
    ].includes(hostname);

    if (supportsAnitaAppProxy && pathname.startsWith('/apps/anita/')) {
      return '/apps/anita';
    }

    return fallback;
  }

  function detectAnitaBrand() {
    const explicit = String(window.anitaConfig?.brand || window.anitaConfig?.site || '').trim().toLowerCase();
    if (['leitner', 'leitnerheadsets', 'leitner-headsets', 'leitner headsets'].includes(explicit)) return 'leitner';
    if (['headsets', 'headsetscom', 'headsets.com', 'headsets-com'].includes(explicit)) return 'headsets';

    const hostname = window.location.hostname.toLowerCase();
    if (hostname === 'leitnerheadsets.com' || hostname === 'www.leitnerheadsets.com') return 'leitner';
    return 'headsets';
  }

  function getFallbackGreeting() {
    if (config.brand === 'leitner') {
      return "Hi! I'm Anita, your Leitner Headsets assistant. How can I help you with your Leitner headset today?";
    }

    return "Hi! I'm Anita, your Headsets.com assistant. How can I help you?";
  }

  // Configurable API base (set window.anitaConfig = { apiBase: '...' }; before loading script)
  const config = {
    apiBase: getDefaultApiBase(),
    brand: detectAnitaBrand(),
    // Callback request prototype settings. Chris can change these without touching the rest of the widget.
    requestEndpoint: window.anitaConfig?.requestEndpoint || window.anitaConfig?.callbackEndpoint || '/api/chat/contact-request',
    callbackEndpoint: window.anitaConfig?.callbackEndpoint || '/api/chat/contact-request',
    callbackRecipient: window.anitaConfig?.callbackRecipient || 'AIF@headsets.com',
    dashboardBase: window.anitaConfig?.dashboardBase || 'https://anita.zipdex.com/admin',
    callbackTestMode: window.anitaConfig?.callbackTestMode || false
  };

  const keys = {
    sessionId: 'anita-session-id',
    messages: 'anita-messages',
    state: 'anita-chat-state',
    lastActivity: 'anita-last-activity'
  };

  let currentSessionId = null;
  let messages = [];
  let rateLimitUntil = 0;
  let contactOfferPending = false;
  let chatButton, chatPanel, messagesContainer, textarea, sendBtn, typingIndicator;
  let comm100Button, comm100Container;
  let pendingUserMessages = [];
  let activeUserMessages = [];
  let messageQueueTimer = null;
  let processingMessageQueue = false;
  let rerunRequested = false;
  let activeChatController = null;
  const messageCoalesceMs = 700;

  const memoryStore = {};
  const storage = {
    get: (key) => {
      try {
        const item = localStorage.getItem(key);
        if (item) return JSON.parse(item);
        return memoryStore[key] || null;
      } catch {
        return memoryStore[key] || null;
      }
    },
    set: (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
      } catch {
        // localStorage is unavailable. Use in-memory store.
      }
      memoryStore[key] = value;
    }
  };

  function isSessionValid() {
    const lastActivity = storage.get(keys.lastActivity);
    if (!lastActivity) return false;
    return (Date.now() - lastActivity) < 7200000; // 2 hours
  }

  function clearSession() {
    localStorage.removeItem(keys.sessionId);
    localStorage.removeItem(keys.messages);
    localStorage.removeItem(keys.state);
    localStorage.removeItem(keys.lastActivity);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function linkifyUrls(text) {
    return text.replace(/(https?:\/\/[^\s<>&"']+)/g, function(url) {
      return '<a href="' + url + '" data-anita-chat-link="true" style="color:#1149af;text-decoration:underline;">' + url + '</a>';
    });
  }

  function injectCSS() {
    if (document.getElementById('anita-chat-css')) return;
    const style = document.createElement('style');
    style.id = 'anita-chat-css';
    style.textContent = `
      #anita-chat-button {
        position: fixed;
        bottom: 25px;
        right: 25px;
        width: 50px;
        height: 50px;
        background: #1149af;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 100000;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: fadeIn 2s ease-out;
        transition: transform 0.2s ease-in-out;
      }
      #anita-chat-button:hover {
        transform: scale(1.05);
      }
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px) scale(0.9); }
        to { opacity: 1; transform: translateY(0) scale(1); }
      }
      #anita-chat-button svg {
        width: 33px;
        height: 33px;
        color: white;
      }
      #anita-chat-panel {
        position: fixed;
        bottom: 0;
        right: 20px;
        width: 350px;
        height: 550px;
        background: white;
        border-radius: 12px 12px 0 0;
        box-shadow: 0 -8px 32px rgba(0,0,0,0.25);
        display: none;
        flex-direction: column;
        z-index: 100001;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        max-height: 80vh;
        overflow: hidden;
      }
      .header {
        background: linear-gradient(135deg, #1149af 0%, #0d3a8a 100%);
        color: white;
        padding: 20px 20px 16px;
        border-radius: 12px 12px 0 0;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      .header .title {
        font-size: 18px;
        font-weight: 600;
      }
      .header .subtitle {
        font-size: 14px;
        opacity: 0.9;
      }
      .close-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        background: none;
        border: none;
        color: white;
        font-size: 24px;
        cursor: pointer;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        transition: background-color 0.2s;
      }
      .close-btn:hover {
        background: rgba(255,255,255,0.2);
      }
      .messages {
        flex: 1;
        padding: 20px;
        background: #f8f9fa;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
      .messages::-webkit-scrollbar {
        width: 4px;
      }
      .messages::-webkit-scrollbar-track {
        background: transparent;
      }
      .messages::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 2px;
      }
      .message {
        display: flex;
        gap: 12px;
        max-width: 85%;
        animation: messageAppear 0.3s ease-out;
      }
      @keyframes messageAppear {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .message.bot {
        align-self: flex-start;
      }
      .message.user {
        align-self: flex-end;
        flex-direction: row-reverse;
      }
      .avatar {
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        background: #1149af;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        font-weight: 600;
      }
      .content {
        padding: 12px 16px;
        border-radius: 20px;
        font-size: 15px;
        line-height: 1.4;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: anywhere;
        min-width: 0;
      }
      .content a {
        word-break: break-all;
        overflow-wrap: anywhere;
      }
      .message.bot .content {
        background: white;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      }
      .message.user .content {
        background: #1149af;
        color: white;
      }
      .typing-indicator {
        padding: 0 20px 20px;
        display: none;
        align-items: center;
      }
      .dots {
        display: flex;
        gap: 4px;
      }
      .dots span {
        width: 8px;
        height: 8px;
        background: #999;
        border-radius: 50%;
        animation: typingDots 1.4s infinite ease-in-out;
      }
      .dots span:nth-child(2) { animation-delay: 0.2s; }
      .dots span:nth-child(3) { animation-delay: 0.4s; }
      @keyframes typingDots {
        0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
        30% { transform: translateY(-8px); opacity: 1; }
      }
      .input-area {
        padding: 16px 20px 20px;
        display: flex;
        gap: 12px;
        border-top: 1px solid #e9ecef;
        background: white;
      }
      .input-area textarea {
        flex: 1;
        border: 1px solid #dee2e6;
        border-radius: 24px;
        padding: 14px 20px;
        resize: none;
        font-size: 15px;
        line-height: 1.4;
        max-height: 120px;
        overflow-y: auto;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .input-area textarea:focus {
        outline: none;
        border-color: #1149af;
        box-shadow: 0 0 0 3px rgba(17,73,175,0.1);
      }
      .send-btn {
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        background: #1149af;
        color: white;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        font-size: 18px;
        transition: background-color 0.2s, transform 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .send-btn:hover:not(:disabled) {
        background: #0d3a8a;
        transform: scale(1.05);
      }
      .send-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
      }
      #anita-rating-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100002;
        backdrop-filter: blur(4px);
      }
      .rating-content {
        background: white;
        padding: 32px;
        border-radius: 16px;
        text-align: center;
        max-width: 90vw;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 60px rgba(0,0,0,0.3);
      }
      .rating-content h3 {
        margin: 0 0 16px;
        font-size: 20px;
        color: #333;
      }
      .stars {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin: 24px 0;
      }
      .star {
        font-size: 36px;
        color: #ddd;
        cursor: pointer;
        transition: color 0.2s, transform 0.2s;
        user-select: none;
      }
      .star:hover,
      .star.selected {
        color: #ffd700;
        transform: scale(1.1);
      }
      .rating-note {
        width: 100%;
        min-height: 80px;
        padding: 12px 16px;
        border: 1px solid #dee2e6;
        border-radius: 12px;
        font-size: 14px;
        resize: vertical;
        font-family: inherit;
        box-sizing: border-box;
      }
      .rating-note:focus {
        outline: none;
        border-color: #1149af;
        box-shadow: 0 0 0 3px rgba(17,73,175,0.1);
      }
      .rating-submit {
        background: linear-gradient(135deg, #1149af 0%, #0d3a8a 100%);
        color: white;
        border: none;
        padding: 12px 32px;
        border-radius: 12px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        margin-top: 16px;
        transition: transform 0.2s;
      }
      .rating-submit:hover {
        transform: translateY(-1px);
      }

      .callback-offer {
        margin: 8px 0 0 44px;
        max-width: 85%;
        display: flex;
        flex-direction: column;
        gap: 8px;
        animation: messageAppear 0.3s ease-out;
      }
      .callback-offer-text {
        background: #ffffff;
        border: 1px solid #dbe6ff;
        border-radius: 16px;
        padding: 12px 14px;
        color: #151515;
        font-size: 14px;
        line-height: 1.4;
        box-shadow: 0 2px 8px rgba(0,0,0,0.06);
      }
      .callback-request-btn,
      .callback-submit-btn {
        align-self: flex-start;
        background: #1149af;
        color: #ffffff;
        border: 0;
        border-radius: 999px;
        padding: 10px 16px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s, transform 0.2s;
      }
      .callback-request-btn:hover,
      .callback-submit-btn:hover:not(:disabled) {
        background: #0d3a8a;
        transform: translateY(-1px);
      }
      .callback-submit-btn:disabled {
        opacity: 0.65;
        cursor: not-allowed;
      }
      #anita-callback-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2147483647;
        backdrop-filter: blur(4px);
      }
      .callback-modal-content {
        background: #ffffff;
        width: 420px;
        max-width: calc(100vw - 32px);
        max-height: 90vh;
        overflow-y: auto;
        border-radius: 18px;
        box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        padding: 24px;
        color: #151515;
      }
      .callback-modal-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 16px;
        margin-bottom: 12px;
      }
      .callback-modal-header h3 {
        margin: 0;
        font-size: 20px;
        line-height: 1.25;
      }
      .callback-modal-close {
        background: none;
        border: none;
        font-size: 24px;
        line-height: 1;
        color: #666;
        cursor: pointer;
      }
      .callback-modal-content p {
        margin: 0 0 16px;
        font-size: 14px;
        line-height: 1.45;
        color: #333;
      }
      .callback-field {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-bottom: 12px;
      }
      .callback-field label {
        font-size: 14px;
        font-weight: 600;
      }
      .callback-field input,
      .callback-field textarea {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        padding: 11px 12px;
        font: inherit;
      }
      .callback-field input:focus,
      .callback-field textarea:focus {
        outline: none;
        border-color: #1149af;
        box-shadow: 0 0 0 3px rgba(17,73,175,0.1);
      }
      .callback-status {
        margin-top: 12px;
        font-size: 14px;
        line-height: 1.4;
      }
      .callback-status.error { color: #b00020; }
      .callback-status.success { color: #0f7a35; }

      @media (max-width: 768px) {
        #anita-chat-panel {
          right: 0;
          width: 100vw;
          height: 100vh;
          border-radius: 0;
          max-height: none;
        }
        #anita-chat-button {
          bottom: 20px;
          right: 20px;
        }
        .input-area {
          padding: 16px;
        }
        .messages {
          padding: 16px;
        }
        .header {
          padding: 20px 16px 16px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function findComm100() {
    comm100Button = document.getElementById('comm100-button-9e020000-0000-0000-0000-008e0003561e');
    comm100Container = document.getElementById('comm100-container');
  }

  function checkComm100Visibility() {
    if (!comm100Button) {
      showChatButton();
      return;
    }
    const iframe = comm100Button.querySelector('iframe');
    const visible = iframe && getComputedStyle(iframe).display !== 'none';
    if (visible) {
      hideChatButton();
    } else {
      showChatButton();
    }
  }

  function setupMutationObserver() {
    if (!comm100Button) return;
    const observer = new MutationObserver(checkComm100Visibility);
    observer.observe(comm100Button, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'display']
    });
    setInterval(checkComm100Visibility, 5000);
  }

  function showChatButton() {
    if (chatButton) chatButton.style.display = 'flex';
  }

  function hideChatButton() {
    if (chatButton) chatButton.style.display = 'none';
    if (chatPanel) chatPanel.style.display = 'none';
  }

  function hideComm100() {
    if (comm100Container) {
      comm100Container.style.display = 'none';
    }
  }

  function showComm100() {
    if (comm100Container) {
      comm100Container.style.display = '';
    }
  }

  function loadMessages() {
    messages = storage.get(keys.messages) || [];
    renderMessages();
  }

  function saveMessages() {
    storage.set(keys.messages, messages);
  }

  function renderMessages() {
    if (!messagesContainer) return;
    messagesContainer.innerHTML = '';
    messages.forEach(({ role, content }) => {
      addMessageEl(role, content);
    });
    scrollToBottom();
  }

  function addMessage(role, content) {
    messages.push({ role, content });
    saveMessages();
    addMessageEl(role, content);
  }

  function addMessageEl(role, content) {
    const staleThemeWelcome = messagesContainer && messagesContainer.querySelector('.anita-welcome-row');
    if (staleThemeWelcome) staleThemeWelcome.remove();

    const msgEl = document.createElement('div');
    msgEl.className = `message ${role}`;
    if (role === 'bot') {
      msgEl.innerHTML = `
        <div class="avatar">AI</div>
        <div class="content">${linkifyUrls(escapeHtml(content))}</div>
      `;
    } else {
      msgEl.innerHTML = `
        <div class="content">${escapeHtml(content)}</div>
      `;
    }
    messagesContainer.appendChild(msgEl);
    scrollToNewMessage(msgEl, role);
  }

  function minimizeChatForLinkClick() {
    if (chatPanel) {
      chatPanel.style.display = 'none';
    }
    storage.set(keys.state, 'closed');
    storage.set(keys.lastActivity, Date.now());
    showComm100();
  }

  function scrollToNewMessage(msgEl, role) {
    if (!messagesContainer) return;
    if (role === 'bot') {
      // Scroll so the START of the bot message is visible at top of chat area
      requestAnimationFrame(() => {
        msgEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } else {
      // For user messages, scroll to bottom as usual
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  }

  function scrollToBottom() {
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  }

  function showTyping(show) {
    if (typingIndicator) {
      typingIndicator.style.display = show ? 'flex' : 'none';
    }
  }


  function normalizeContactIntent(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[’']/g, "'")
      .replace(/[^a-z0-9']+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isContactIntent(text) {
    const normalized = normalizeContactIntent(text);
    const direct = normalized
      .replace(/^(please\s+)+/, '')
      .replace(/(\s+please)+$/, '');

    const directPhrases = new Set([
      'agent',
      'human',
      'representative',
      'rep',
      'real person',
      'live person',
      'live agent',
      'customer service',
      'headset advisor',
      'someone real'
    ]);

    if (directPhrases.has(direct)) return true;

    return [
      /\b(can|could|may)\s+i\s+(speak|talk|chat)\s+(with|to)\s+((a\s+)?(real\s+)?(person|human|representative|rep|agent)|someone\s+real)\b/,
      /\bi\s+(need|want|would\s+like)\s+to\s+(speak|talk|chat)\s+(with|to)\s+(someone|somebody|(a\s+)?(real\s+)?(person|human|representative|rep|agent))\b/,
      /\b(need|want|would\s+like)\s+to\s+(speak|talk|chat)\s+(with|to)\s+(someone|somebody|(a\s+)?(real\s+)?(person|human|representative|rep|agent))\b/,
      /\b(can|could|would)\s+someone\s+(call|email)\s+me\b/,
      /\b(can|could|would)\s+you\s+(call|email)\s+me\b/,
      /\bplease\s+call\s+me\s+back\b/,
      /\bcall\s+me\s+back\b/,
      /\bsend\s+me\s+(an?\s+)?email\b/,
      /\bi\s+do\s+not\s+want\s+(an?\s+)?ai\b/,
      /\bi\s+don't\s+want\s+(an?\s+)?ai\b/,
      /\b(want|need)\s+(a\s+)?(person|human|representative|rep|agent)\s+to\s+help\b/
    ].some((pattern) => pattern.test(normalized));
  }

  function isContactAcceptance(text) {
    return contactOfferPending && /\b(yes|yeah|yep|sure|please|ok|okay|sounds good|that works|call me|email me)\b/i.test(text);
  }

  function buildDashboardLink() {
    if (!currentSessionId) return config.dashboardBase;
    return `${config.dashboardBase}?sessionId=${encodeURIComponent(currentSessionId)}`;
  }

  function getTranscriptText() {
    return messages.map((message) => {
      const speaker = message.role === 'user' ? 'Customer' : 'Anita';
      return `${speaker}: ${message.content}`;
    }).join('\n\n');
  }

  function resolveRequestEndpoint() {
    const endpoint = config.requestEndpoint || config.callbackEndpoint;
    if (/^https?:\/\//i.test(endpoint)) return endpoint;
    return `${config.apiBase}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`;
  }

  function showContactOffer() {
    if (!messagesContainer) return;
    contactOfferPending = true;

    const existing = document.getElementById('anita-callback-offer');
    if (existing) existing.remove();

    const offer = document.createElement('div');
    offer.id = 'anita-callback-offer';
    offer.className = 'callback-offer';
    offer.innerHTML = `
      <button type="button" class="callback-request-btn" data-request-type="callback">Request a callback</button>
      <button type="button" class="callback-request-btn" data-request-type="email">Request an email</button>
    `;
    offer.querySelector('[data-request-type="callback"]').addEventListener('click', () => showContactForm('callback'));
    offer.querySelector('[data-request-type="email"]').addEventListener('click', () => showContactForm('email'));
    messagesContainer.appendChild(offer);
    scrollToNewMessage(offer, 'bot');
  }

  function showContactForm(requestType) {
    contactOfferPending = false;

    const existing = document.getElementById('anita-callback-modal');
    if (existing) existing.remove();

    const isEmail = requestType === 'email';
    const title = isEmail ? 'Request an email' : 'Request a callback';
    const contactField = isEmail
      ? `<div class="callback-field"><label for="anita-contact-email">Email</label><input id="anita-contact-email" name="email" type="email" autocomplete="email"></div>`
      : `<div class="callback-field"><label for="anita-contact-phone">Phone number</label><input id="anita-contact-phone" name="phone" type="tel" autocomplete="tel"></div>`;

    const modal = document.createElement('div');
    modal.id = 'anita-callback-modal';
    modal.innerHTML = `
      <div class="callback-modal-content" role="dialog" aria-modal="true" aria-labelledby="anita-contact-title">
        <div class="callback-modal-header">
          <h3 id="anita-contact-title">${title}</h3>
          <button type="button" class="callback-modal-close" aria-label="Close">×</button>
        </div>
        <form id="anita-contact-form" data-request-type="${requestType}" novalidate>
          <div class="callback-field">
            <label for="anita-contact-name">Name</label>
            <input id="anita-contact-name" name="name" autocomplete="name">
          </div>
          ${contactField}
          <div class="callback-field">
            <label for="anita-contact-notes">Anything else?</label>
            <textarea id="anita-contact-notes" name="notes" rows="3"></textarea>
          </div>
          <button type="submit" class="callback-submit-btn">Send request</button>
          <div class="callback-status" aria-live="polite"></div>
        </form>
      </div>
    `;

    const close = () => modal.remove();
    modal.querySelector('.callback-modal-close').addEventListener('click', close);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) close();
    });
    modal.querySelector('form').addEventListener('submit', submitContactRequest);

    document.body.appendChild(modal);
    const nameInput = modal.querySelector('#anita-contact-name');
    if (nameInput) nameInput.focus();
  }

  async function submitContactRequestFallback(payload) {
    const endpoint = 'https://submit-form.com/kXE2V3gJ5';
    const customer = payload.customer || {};
    const label = payload.requestType === 'email' ? 'email request' : 'callback request';
    const subjectContact = payload.requestType === 'email'
      ? (customer.email || 'No email provided')
      : (customer.phone || 'No phone provided');
    const formPayload = {
      name: customer.name || '(not provided)',
      phone: customer.phone || '(not provided)',
      email: customer.email || '(not provided)',
      requestType: payload.requestType || 'callback',
      notes: customer.notes || '(none)',
      pageUrl: payload.pageUrl || window.location.href,
      anitaAdminLink: payload.dashboardLink || buildDashboardLink(),
      sessionId: payload.sessionId || currentSessionId || '(not provided)',
      submittedAt: payload.submittedAt || new Date().toISOString(),
      transcript: payload.transcript || getTranscriptText(),
      _botpoison: payload._botpoison || '',
      '_email.from': 'Headsets com',
      '_email.subject': 'Anita ' + label + ': ' + (customer.name || 'Unknown customer') + ' - ' + subjectContact
    };

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(formPayload)
    });

    if (!response.ok) throw new Error('Fallback contact form failed: HTTP ' + response.status);
  }

  async function submitContactRequest(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const status = form.querySelector('.callback-status');
    const submitBtn = form.querySelector('.callback-submit-btn');
    const formData = new FormData(form);
    const requestType = form.dataset.requestType || 'callback';

    let botpoisonSolution = '';
    if (window.Botpoison) {
      try {
        const botpoison = new window.Botpoison({ publicKey: 'pk_fa62db49-fed7-4578-8647-85210bc16a19' });
        const result = await botpoison.challenge();
        botpoisonSolution = result && result.solution ? result.solution : '';
      } catch (error) {
        console.warn('BotPoison challenge failed:', error);
      }
    }

    const payload = {
      to: config.callbackRecipient,
      _botpoison: botpoisonSolution,
      requestType,
      sessionId: currentSessionId,
      dashboardLink: buildDashboardLink(),
      pageUrl: window.location.href,
      brand: config.brand,
      submittedAt: new Date().toISOString(),
      customer: {
        name: String(formData.get('name') || '').trim(),
        phone: String(formData.get('phone') || '').trim(),
        email: String(formData.get('email') || '').trim(),
        notes: String(formData.get('notes') || '').trim()
      },
      transcript: getTranscriptText(),
      messages: messages.slice()
    };

    submitBtn.disabled = true;
    status.className = 'callback-status';
    status.textContent = 'Sending request...';

    try {
      if (config.callbackTestMode) {
        console.log('Anita contact request payload:', payload);
        await new Promise((resolve) => setTimeout(resolve, 500));
      } else {
        try {
          const response = await fetch(resolveRequestEndpoint(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
        } catch (primaryError) {
          console.warn('Anita contact endpoint failed; trying storefront fallback form:', primaryError);
          await submitContactRequestFallback(payload);
        }
      }

      status.className = 'callback-status success';
      status.textContent = "You're all set — we've sent your request to the team.";
      setTimeout(() => {
        const modal = document.getElementById('anita-callback-modal');
        if (modal) modal.remove();
      }, 1400);
    } catch (error) {
      console.error('Contact request failed:', error);
      status.className = 'callback-status error';
      status.textContent = 'Something went wrong sending that request. Please call us at 1-800-HEADSETS or email hello@headsets.com.';
      submitBtn.disabled = false;
    }
  }

  function buildFirstMessageWithVisibleContext(userMessage) {
    const trimmed = (userMessage || '').trim();
    if (!trimmed) return userMessage;
    const visibleMessages = Array.isArray(messages) ? messages.filter((msg) => msg && msg.content) : [];
    if (visibleMessages.length < 2) return userMessage;

    const starterUser = visibleMessages.find((msg) => msg.role === 'user' && msg.content && msg.content !== trimmed);
    const starterBot = [...visibleMessages].reverse().find((msg) => msg.role === 'bot' && msg.content);
    if (!starterUser || !starterBot) return userMessage;

    return 'Visible chat context before this message:\n' +
      'Customer selected: "' + starterUser.content + '"\n' +
      'Anita already replied: "' + starterBot.content + '"\n\n' +
      'Treat the customer\'s next message as a follow-up/answer to Anita\'s visible reply. Do not repeat the same starter question.\n\n' +
      'Customer follow-up: ' + trimmed;
  }

  async function fetchApi(endpoint, body, options = {}) {
    const controller = options.controller || new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 60000);

    try {
      const now = Date.now();
      if (now < rateLimitUntil) {
        const wait = Math.ceil((rateLimitUntil - now) / 1000);
        throw new Error('rate_limited_local');
      }

      const response = await fetch(`${config.apiBase}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller.signal
      });

      if (response.status === 429) {
        const retryAfter = response.headers.get('Retry-After');
        const delay = retryAfter ? parseInt(retryAfter) * 1000 : 60000;
        rateLimitUntil = Date.now() + delay;
        throw new Error('rate_limited');
      }

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      return await response.json();
    } finally {
      clearTimeout(timeoutId);
    }
  }

  async function startSession(userMessage) {
    showTyping(true);
    try {
      // Step 1: Create session and get greeting
      const startRes = await fetchApi('/api/chat/start', { visitorPage: window.location.href, brand: config.brand });
      currentSessionId = startRes.sessionId;
      storage.set(keys.sessionId, currentSessionId);
      addMessage('bot', startRes.message || getFallbackGreeting());
      storage.set(keys.lastActivity, Date.now());

      // Step 2: Send the user's first message. If the Shopify search UI already
      // showed a Top 5 starter exchange before opening the full widget, include
      // that visible exchange so Anita's backend session continues from it.
      if (userMessage) {
        const apiMessage = buildFirstMessageWithVisibleContext(userMessage);
        const res = await fetchApi('/api/chat/message', { sessionId: currentSessionId, message: apiMessage, brand: config.brand, visitorInfo: { page: window.location.href } });
        currentSessionId = res.sessionId || currentSessionId;
        storage.set(keys.sessionId, currentSessionId);
        addMessage('bot', res.reply);
        if (res.handoff) {
          console.log('Handoff triggered');
          showContactOffer();
        }
      }
    } catch (error) {
      let fallback = "I'm having a small issue right now. Please try again, or call us at 1-800-HEADSETS!";
      if (error.name === 'AbortError') {
        fallback = 'Request timed out. Please try again.';
      }
      addMessage('bot', fallback);
    } finally {
      showTyping(false);
      storage.set(keys.lastActivity, Date.now());
    }
  }

  function formatQueuedMessage(parts) {
    if (parts.length === 1) return parts[0];
    return 'The customer sent multiple messages in a row. Answer their latest need using all of these messages together:\n' +
      parts.map((part, index) => `${index + 1}. ${part}`).join('\n');
  }

  async function callChatMessage(message, controller) {
    const res = await fetchApi('/api/chat/message', { sessionId: currentSessionId, message, brand: config.brand, visitorInfo: { page: window.location.href } }, { controller });
    currentSessionId = res.sessionId || currentSessionId;
    storage.set(keys.sessionId, currentSessionId);
    return res;
  }

  function scheduleMessageQueue(delay = messageCoalesceMs) {
    clearTimeout(messageQueueTimer);
    messageQueueTimer = setTimeout(processMessageQueue, delay);
  }

  function requestQueuedRerun() {
    if (!processingMessageQueue) return;
    if (!rerunRequested) {
      pendingUserMessages = activeUserMessages.concat(pendingUserMessages);
      rerunRequested = true;
    }
    if (activeChatController) {
      activeChatController.abort();
    }
  }

  async function processMessageQueue() {
    clearTimeout(messageQueueTimer);
    if (processingMessageQueue || !pendingUserMessages.length) return;

    processingMessageQueue = true;
    rerunRequested = false;
    activeUserMessages = pendingUserMessages.splice(0);
    activeChatController = new AbortController();
    showTyping(true);

    try {
      if (!currentSessionId) {
        await startSession();
      }

      const queuedMessage = formatQueuedMessage(activeUserMessages);
      const res = await callChatMessage(queuedMessage, activeChatController);

      if (!rerunRequested && !pendingUserMessages.length) {
        addMessage('bot', res.reply);
        if (res.handoff) {
          console.log('Handoff triggered');
          showContactOffer();
        }
        if (activeUserMessages.some(isContactIntent)) {
          showContactOffer();
        }
      }
    } catch (error) {
      if (!(error.name === 'AbortError' && rerunRequested)) {
        let fallback = 'Sorry, something went wrong. Please try again.';
        if (error.message === 'rate_limited' || error.message === 'rate_limited_local') {
          const wait = Math.ceil((rateLimitUntil - Date.now()) / 1000);
          fallback = `Rate limited. Please wait ${wait} seconds.`;
        } else if (error.name === 'AbortError') {
          fallback = 'Request timed out. Please try again.';
        }
        addMessage('bot', fallback);
      }
    } finally {
      activeChatController = null;
      activeUserMessages = [];
      processingMessageQueue = false;
      showTyping(false);
      storage.set(keys.lastActivity, Date.now());
      if (pendingUserMessages.length) {
        scheduleMessageQueue(150);
      }
    }
  }

  async function sendToApi(message) {
    showTyping(true);
    try {
      const res = await callChatMessage(message);
      addMessage('bot', res.reply);
      if (res.handoff) {
        console.log('Handoff triggered');
        showContactOffer();
      }
      if (isContactIntent(message)) {
        showContactOffer();
      }
    } catch (error) {
      let fallback = 'Sorry, something went wrong. Please try again.';
      if (error.message === 'rate_limited' || error.message === 'rate_limited_local') {
        const wait = Math.ceil((rateLimitUntil - Date.now()) / 1000);
        fallback = `Rate limited. Please wait ${wait} seconds.`;
      } else if (error.name === 'AbortError') {
        fallback = 'Request timed out. Please try again.';
      }
      addMessage('bot', fallback);
    } finally {
      showTyping(false);
      storage.set(keys.lastActivity, Date.now());
    }
  }

  async function sendMessage(text) {
    const trimmed = text.trim();
    if (!trimmed || trimmed.length > 500) return;

    const acceptedCallback = isContactAcceptance(trimmed);
    addMessage('user', trimmed);

    if (acceptedCallback) {
      showContactForm('callback');
      return;
    }

    if (isContactIntent(trimmed)) {
      showContactOffer();
      return;
    }

    pendingUserMessages.push(trimmed);
    if (processingMessageQueue) {
      requestQueuedRerun();
      return;
    }
    scheduleMessageQueue();
  }

  function createChatButton() {
    chatButton = document.createElement('div');
    chatButton.id = 'anita-chat-button';
    chatButton.innerHTML = `<svg width="33" height="33" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5832 24.75H13.7498L6.4165 32.0833V24.75H2.74984C2.26361 24.75 1.79729 24.5569 1.45347 24.213C1.10966 23.8692 0.916504 23.4029 0.916504 22.9167V2.75001C0.916504 2.26377 1.10966 1.79746 1.45347 1.45364C1.79729 1.10983 2.26361 0.916672 2.74984 0.916672H33.9165C34.4027 0.916672 34.869 1.10983 35.2129 1.45364C35.5567 1.79746 35.7498 2.26377 35.7498 2.75001V13.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.25 33.9167C19.25 34.4029 19.4432 34.8692 19.787 35.213C20.1308 35.5569 20.5971 35.75 21.0833 35.75H31.1667L39.4167 43.0833V35.75H41.25C41.7362 35.75 42.2025 35.5569 42.5464 35.213C42.8902 34.8692 43.0833 34.4029 43.0833 33.9167V19.25C43.0833 18.7638 42.8902 18.2975 42.5464 17.9536C42.2025 17.6098 41.7362 17.4167 41.25 17.4167H21.0833C20.5971 17.4167 20.1308 17.6098 19.787 17.9536C19.4432 18.2975 19.25 18.7638 19.25 19.25V33.9167Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    chatButton.addEventListener('click', toggleChat);
    document.body.appendChild(chatButton);
    checkComm100Visibility();
  }

  function createChatPanel() {
    chatPanel = document.createElement('div');
    chatPanel.id = 'anita-chat-panel';
    chatPanel.style.display = 'flex';

    const header = document.createElement('div');
    header.className = 'header';
    const assistantSubtitle = config.brand === 'leitner' ? 'AI Assistant • Leitner Headsets' : 'AI Assistant • Headsets.com';
    header.innerHTML = `
      <div class="title">Chat with Anita</div>
      <div class="subtitle">${assistantSubtitle}</div>
    `;
    const closeBtn = document.createElement('button');
    closeBtn.className = 'close-btn';
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closeChat);
    header.appendChild(closeBtn);

    messagesContainer = document.createElement('div');
    messagesContainer.className = 'messages';
    messagesContainer.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-anita-chat-link="true"]');
      if (link) {
        minimizeChatForLinkClick();
      }
    });

    typingIndicator = document.createElement('div');
    typingIndicator.className = 'typing-indicator';
    typingIndicator.innerHTML = '<div class="dots"><span></span><span></span><span></span></div>';
    typingIndicator.style.display = 'none';

    const inputAreaEl = document.createElement('div');
    inputAreaEl.className = 'input-area';
    textarea = document.createElement('textarea');
    textarea.placeholder = config.brand === 'leitner' ? 'Ask about Leitner headsets...' : 'Ask about our headsets...';
    textarea.maxLength = 500;
    sendBtn = document.createElement('button');
    sendBtn.className = 'send-btn';
    sendBtn.textContent = '→';
    sendBtn.disabled = true;
    inputAreaEl.append(textarea, sendBtn);

    chatPanel.append(header, messagesContainer, typingIndicator, inputAreaEl);
    document.body.appendChild(chatPanel);

    setupInputListeners();
    if (currentSessionId) {
      loadMessages();
    }
  }

  function setupInputListeners() {
    const toggleSendBtn = () => {
      sendBtn.disabled = !textarea.value.trim();
    };

    textarea.addEventListener('input', () => {
      toggleSendBtn();
      storage.set(keys.lastActivity, Date.now());
    });

    sendBtn.addEventListener('click', () => {
      sendMessage(textarea.value);
      textarea.value = '';
      toggleSendBtn();
    });

    textarea.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendBtn.click();
      }
    });
  }

  function toggleChat() {
    if (chatPanel && chatPanel.style.display !== 'none') {
      closeChat();
    } else {
      if (!chatPanel) {
        createChatPanel();
        // Start session and show greeting on first open
        if (!currentSessionId) {
          startSession(null);
        }
      } else {
        chatPanel.style.display = 'flex';
      }
      storage.set(keys.state, 'open');
      hideComm100();
      if (textarea) setTimeout(() => textarea.focus(), 100);
    }
  }

  function closeChat() {
    if (chatPanel) {
      chatPanel.style.display = 'none';
    }
    storage.set(keys.state, 'closed');
    showComm100();
    if (currentSessionId) {
      showRating();
    }
  }

  function showRating() {
    const modal = document.createElement('div');
    modal.id = 'anita-rating-modal';
    modal.innerHTML = `
      <div class="rating-content">
        <h3>How would you rate your chat?</h3>
        <div class="stars">
          <span class="star" data-rating="1">★</span>
          <span class="star" data-rating="2">★</span>
          <span class="star" data-rating="3">★</span>
          <span class="star" data-rating="4">★</span>
          <span class="star" data-rating="5">★</span>
        </div>
        <textarea class="rating-note" placeholder="Optional feedback (what could we improve?)..."></textarea>
        <button class="rating-submit">Submit Feedback</button>
      </div>
    `;
    document.body.appendChild(modal);

    let selectedRating = 0;
    modal.querySelectorAll('.star').forEach((star) => {
      star.addEventListener('click', () => {
        selectedRating = parseInt(star.dataset.rating);
        modal.querySelectorAll('.star').forEach((s, i) => {
          s.classList.toggle('selected', i < selectedRating);
        });
      });
      star.addEventListener('mouseenter', () => {
        if (!selectedRating) {
          modal.querySelectorAll('.star').forEach((s, i) => {
            s.classList.toggle('selected', i < parseInt(star.dataset.rating));
          });
        }
      });
    });
    modal.querySelectorAll('.star').forEach(star => {
      star.addEventListener('mouseleave', () => {
        if (!selectedRating) {
          modal.querySelectorAll('.star').forEach(s => s.classList.remove('selected'));
        }
      });
    });

    const noteEl = modal.querySelector('.rating-note');
    const submitBtn = modal.querySelector('.rating-submit');
    submitBtn.addEventListener('click', async () => {
      if (selectedRating === 0) return;
      try {
        await fetchApi('/api/chat/rate', {
          sessionId: currentSessionId,
          rating: selectedRating,
          note: noteEl.value.trim()
        });
      } catch (e) {
        console.error('Rating submission failed:', e);
      }
      document.body.removeChild(modal);
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        document.body.removeChild(modal);
      }
    });
  }

  function init() {
    injectCSS();
    findComm100();
    const valid = isSessionValid();
    if (valid) {
      currentSessionId = storage.get(keys.sessionId);
    } else {
      clearSession();
    }
    const savedState = storage.get(keys.state);
    createChatButton();
    if (valid && savedState === 'open') {
      createChatPanel();
    }
    setupMutationObserver();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



